(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pp-personalizer"] && !Shopify.designMode) return;
  try {
    /* Jam Up bundle building adapter — 1.4.0.
 * Observed Yoycol storefront SDK integration, 2026-09-12.
 * Requires a dedicated same-origin Shopify team page and the Yoycol storefront SDK.
 * No vendor credentials are read or handled by this adapter.
 */
(function (global) {
  'use strict';

  const LABELS = ['Front Name', 'Back Name', 'Front Logo', 'Back Logo', 'Left Sleeve Logo', 'Right Sleeve Logo'];
  const LOGO_LABELS = LABELS.slice(2);
  let hostSequence = 0;
  const canonical = value => String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
  const fieldLabel = value => {
    const label = canonical(value);
    return label === 'name front' ? 'front name' : label === 'name back' ? 'back name' : label;
  };
  const clone = value => JSON.parse(JSON.stringify(value));
  const valueId = value => String(value == null ? '' : value);
  const sameId = (a, b) => valueId(a) === valueId(b);
  const isRecord = value => value && typeof value === 'object' && !Array.isArray(value);

  class TeamOrderError extends Error {
    constructor(message, code, details) {
      super(message);
      this.name = 'PaneBundleError';
      this.code = code;
      Object.assign(this, details || {});
    }
  }

  function fail(message, code, details) { throw new TeamOrderError(message, code, details); }
  function abortCheck(signal) {
    if (signal && signal.aborted) fail('Bundle preparation was cancelled.', 'ABORTED');
  }
  function httpUrl(value, label) {
    let url;
    try { url = new global.URL(value); } catch (_) { fail(label + ' is unavailable.', 'INVALID_MANUFACTURER_OUTPUT'); }
    if (url.protocol !== 'https:' && url.protocol !== 'http:') fail(label + ' was not uploaded successfully.', 'INVALID_MANUFACTURER_OUTPUT');
    return url.href;
  }
  function infoCanvases(info) {
    const parsed = typeof info === 'string' ? JSON.parse(info) : info;
    const canvases = Array.isArray(parsed) ? parsed : parsed && parsed.info;
    if (!Array.isArray(canvases) || !canvases.length) fail('The manufacturer design is incomplete.', 'INVALID_MANUFACTURER_OUTPUT');
    return canvases;
  }
  function elements(info) {
    return infoCanvases(info).flatMap(canvas => Array.isArray(canvas.klass) ? canvas.klass : []);
  }
  function fieldOptions(model) {
    let config = model && model.personalizerConfig;
    if (typeof config === 'string') config = JSON.parse(config);
    if (!config || !Array.isArray(config.personal_options)) fail('This product has no usable personalization configuration.', 'SDK_CONFIGURATION');
    return config.personal_options.filter(option => option.status);
  }
  function rowSignature(row) {
    return JSON.stringify([valueId(row.rowId), valueId(row.productId), row.handle, valueId(row.variantId), row.cut, row.size, row.name || '', row.personalize !== false]);
  }
  function propertySignature(properties) {
    return JSON.stringify(Object.keys(properties).sort().map(key => [key, valueId(properties[key])]));
  }
  function bounded(operation, timeout, signal, message) {
    abortCheck(signal);
    return new Promise((resolve, reject) => {
      let finished = false;
      const finish = (fn, value) => {
        if (finished) return;
        finished = true;
        global.clearTimeout(timer);
        if (signal) signal.removeEventListener('abort', onAbort);
        fn(value);
      };
      const onAbort = () => finish(reject, new TeamOrderError('Bundle preparation was cancelled.', 'ABORTED'));
      const timer = global.setTimeout(() => finish(reject, new TeamOrderError(message, 'TIMEOUT')), timeout);
      if (signal) signal.addEventListener('abort', onAbort, { once: true });
      Promise.resolve().then(operation).then(value => finish(resolve, value), error => finish(reject, error));
    });
  }
  function poll(read, timeout, signal, message) {
    return bounded(() => new Promise((resolve, reject) => {
      const start = Date.now();
      const tick = () => {
        if ((signal && signal.aborted) || Date.now() - start >= timeout) return;
        try {
          const result = read();
          if (result) return resolve(result);
          global.setTimeout(tick, 100);
        } catch (error) { reject(error); }
      };
      tick();
    }), timeout, signal, message);
  }

  class PaneBundlePersonalizer {
    constructor(options) {
      const settings = options || {};
      const root = new global.URL(settings.rootUrl || '/', global.location.href);
      if (root.origin !== global.location.origin || root.search || root.hash) fail('Bundle preparation must run on the Shopify storefront.', 'ORIGIN_MISMATCH');
      root.pathname = root.pathname.replace(/\/?$/, '/');
      this.root = root;
      this.shopDomain = settings.shopDomain || (global.Shopify && global.Shopify.shop) || '';
      if (!this.shopDomain) fail('The Shopify shop domain is missing.', 'SHOP_DOMAIN_MISSING');
      this.currency = settings.currency || '';
      this.onProgress = typeof settings.onProgress === 'function' ? settings.onProgress : () => {};
      this.proofs = new Map();
      this.previewAssets = new Map();
      this.busy = false;
      this.hostId = 'pane-personalizer-' + (++hostSequence);
      this.host = null;
      this.needsReload = false;
      this.loadedContext = null;
      this.batchProducts = null;
        this.standardModels = null;
      this.batchManufacturer = null;
    }

    _progress(detail) {
      if (!detail.message) {
        if (detail.phase === 'checking') detail.message = 'Checking your bundle in the cart…';
        else if (detail.phase === 'preparing') detail.message = 'Preparing tee ' + (detail.index + 1) + ' of ' + detail.total + '…';
        else if (detail.phase === 'adding') detail.message = 'Adding tee ' + (detail.index + 1) + ' of ' + detail.total + '…';
        else if (detail.phase === 'prepared') detail.message = detail.index + ' of ' + detail.total + ' tee previews prepared.';
        else if (detail.phase === 'added') detail.message = detail.addedCount + ' of ' + detail.total + ' tees confirmed in the cart.';
      }
      try { this.onProgress(detail); } catch (_) { /* A view callback cannot change order state. */ }
    }

    _validate(groupId, rows) {
      if (typeof groupId !== 'string' || !/^[A-Za-z0-9_-]{1,128}$/.test(groupId)) fail('The bundle identifier is invalid.', 'INVALID_GROUP');
      if (!Array.isArray(rows) || !rows.length) fail('Add at least one tee.', 'EMPTY_ROSTER');
      const ids = new Set();
      rows.forEach(row => {
        if (!isRecord(row) || !/^[A-Za-z0-9_-]{1,128}$/.test(valueId(row.rowId))) fail('A tee identifier is invalid.', 'INVALID_ROSTER');
        if (ids.has(valueId(row.rowId))) fail('Player identifiers must be unique.', 'INVALID_ROSTER');
        ids.add(valueId(row.rowId));
        if (!/^\d+$/.test(valueId(row.productId)) || !/^\d+$/.test(valueId(row.variantId)) || !/^[A-Za-z0-9][A-Za-z0-9-]*$/.test(row.handle || '')) fail('A tee has no valid product and size selection.', 'INVALID_ROSTER', { rowId: row.rowId });
        for (const key of ['name']) {
          if (row[key] != null && typeof row[key] !== 'string') fail('Player names must be text.', 'INVALID_ROSTER', { rowId: row.rowId });
        }
      });
    }

    _validateLogos(logos) {
      if (!isRecord(logos)) fail('The shared logo selection is invalid.', 'INVALID_LOGO');
      for (const [label, file] of Object.entries(logos)) {
        if (!LOGO_LABELS.includes(label)) fail('An unknown logo location was supplied.', 'INVALID_LOGO');
        if (!file) continue;
        if (!(file instanceof global.Blob) || !file.size || !/\.(jpe?g|png)$/i.test(file.name || '') || (file.type && !['image/jpeg', 'image/png'].includes(file.type))) fail(label + ' must be a JPG or PNG file.', 'INVALID_LOGO');
      }
    }

    _validateNameColors(input) {
      if (input == null) return { front: null, back: null };
      if (!isRecord(input) || Object.keys(input).some(key => !['front', 'back'].includes(key))) fail('Choose a valid colour for the front and back names.', 'INVALID_NAME_COLOR');
      const colors = {};
      for (const side of ['front', 'back']) {
        const value = input[side];
        if (value == null) colors[side] = null;
        else if (typeof value === 'string' && /^#[0-9a-f]{6}$/i.test(value)) colors[side] = value.toLowerCase();
        else fail('Name colours must use a six-digit hex colour, such as #ffffff.', 'INVALID_NAME_COLOR');
      }
      return colors;
    }

    _fieldsByLabel(fields) {
      const byLabel = new Map();
      for (const field of fields) {
        const label = fieldLabel(field.title);
        if (byLabel.has(label)) fail('The manufacturer contains duplicate personalization labels.', 'SDK_CONFIGURATION');
        byLabel.set(label, field);
      }
      return byLabel;
    }

    _validateTemplateCapabilities(model, row) {
      const options = fieldOptions(model);
      const names = options.filter(option => option.type === 'group' && canonical(option.form && option.form.name) === 'add your name (free)');
      if (options.length !== 1 || names.length !== 1) fail('This tee’s name options have changed. Please personalise it on its product page or contact us.', 'PERSONALIZATION_UNSUPPORTED', { reference: 'PP-OPTIONS' });
      const option = names[0];
      if (!Array.isArray(option.selectPositions) || !option.selectPositions.length) fail('The name print position is unavailable.', 'SDK_CONFIGURATION');
      if (typeof row.name !== 'string' || (option.form.require && !row.name.trim())) fail('Enter the name for this tee.', 'FIELD_REQUIRED');
      if (option.characterLimit && row.name.length > option.characterLimit) fail('The name is too long for this tee.', 'FIELD_INVALID');
    }

    getPreviewUrl(proof) {
      const asset = this.previewAssets.get(proof);
      return asset && proof.previewUrl === asset.url && proof.properties.preview_image === asset.sourceUrl ? asset.url : '';
    }

    releasePreviews() {
      for (const asset of this.previewAssets.values()) global.URL.revokeObjectURL(asset.url);
      this.previewAssets.clear();
    }

    destroy() { this.releasePreviews(); this._disposeHost(); }

    async _previewAsset(sourceUrl, signal) {
      let response;
      try { response = await this._request(sourceUrl, { credentials: 'omit', mode: 'cors' }, signal, 60000); }
      catch (error) {
        if (error.code === 'ABORTED' || error.name === 'AbortError' || (signal && signal.aborted)) throw error;
        fail('The saved preview could not be loaded for review. No tees were added to the cart. Try preparing your bundle again.', 'PREVIEW_READ_FAILED', { reference: 'PP-PREVIEW' });
      }
      if (!response.ok) fail('The saved preview could not be loaded for review. No tees were added to the cart. Try preparing your bundle again.', 'PREVIEW_READ_FAILED', { reference: 'PP-PREVIEW' });
      const blob = await bounded(() => response.blob(), 60000, signal, 'The saved preview took too long to read.');
      if (!blob.size || !/^image\/(jpeg|png|webp|gif|avif)$/i.test(blob.type)) fail('The saved preview is not a readable image. No tees were added to the cart.', 'PREVIEW_READ_FAILED', { reference: 'PP-PREVIEW' });
      abortCheck(signal);
      const url = global.URL.createObjectURL(blob);
      if (!url.startsWith('blob:' + global.location.origin + '/') || /yoycol/i.test(url)) {
        global.URL.revokeObjectURL(url);
        fail('The saved preview could not be opened securely on this storefront.', 'PREVIEW_READ_FAILED', { reference: 'PP-PREVIEW' });
      }
      return { url, sourceUrl, blob };
    }

    _attachmentFile(blob) {
      const extensions = { 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'image/gif': 'gif', 'image/avif': 'avif' };
      const extension = extensions[blob.type];
      if (!blob.size || !extension) fail('A saved logo or preview is not a readable image.', 'ASSET_READ_FAILED');
      return new global.File([blob], 'preview.' + extension, { type: blob.type });
    }

    _checkNameColors(designs, targets, saved) {
      const current = elements(designs);
      for (const target of targets) {
        const matches = current.filter(item => item.info && item.info.uuid === target.uuid);
        const text = matches.length === 1 && matches[0].info.curveText;
        if (!text || valueId(text.fill).toLowerCase() !== target.color || valueId(text.text) !== target.text || text.fontFamily !== target.fontFamily) {
          fail(target.label + ' colour did not reach the ' + (saved ? 'saved manufacturer design.' : 'manufacturer preview.'), saved ? 'INVALID_MANUFACTURER_OUTPUT' : 'NAME_COLOR_MISMATCH', { reference: 'PP-NAME-COLOR', reloadRequired: !saved });
        }
      }
    }

    async _applyNameColors(context, fields, nameColors, signal) {
      if (!nameColors.front && !nameColors.back) return [];
      const { vendor, options } = context;
      const engine = vendor.engine;
      if (!engine || typeof engine.getDesigns !== 'function') {
        fail('The manufacturer does not currently support name colour selection for this tee.', 'NAME_COLOR_UNAVAILABLE', { reference: 'PP-NAME-COLOR' });
      }
      const designs = clone(infoCanvases(engine.getDesigns()));
      const artwork = elements(designs);
      const original = elements(vendor.getOriginDeisgns());
      const targets = [];
      const selected = new Set();
      let changed = false;
      const byLabel = this._fieldsByLabel(fields);
      for (const [side, label] of [['front', 'Front Name'], ['back', 'Back Name']]) {
        const color = nameColors[side];
        if (!color) continue;
        const field = byLabel.get(fieldLabel(label));
        const option = field && options.find(item => sameId(item.id, field.id));
        if (!field || field.type !== 'text' || !option) {
          fail(label + ' colour cannot be changed for this tee. Choose the default colour.', 'NAME_COLOR_UNAVAILABLE', { reference: 'PP-NAME-COLOR' });
        }
        if (!Array.isArray(option.selectPositions) || !option.selectPositions.length) fail(label + ' has no manufacturer colour location.', 'SDK_CONFIGURATION');
        for (const uuid of option.selectPositions) {
          const matches = artwork.filter(item => item.info && item.info.uuid === uuid);
          const origins = original.filter(item => item.info && item.info.uuid === uuid);
          const item = matches[0];
          if (selected.has(uuid) || matches.length !== 1 || origins.length !== 1 || !item || item.type !== 'group' || !isRecord(item.info.curveText) || !isRecord(origins[0].info.curveText) || valueId(item.info.curveText.text) !== valueId(field.value)) {
            fail(label + ' colour has an incompatible manufacturer location.', 'SDK_CONFIGURATION', { reference: 'PP-NAME-COLOR' });
          }
          selected.add(uuid);
          const editable = option.allowFontColorChange === true;
          if (!editable && (canonical(item.info.curveText.fill) !== color || canonical(origins[0].info.curveText.fill) !== color)) {
            fail(label + ' colour cannot be changed for this tee. Choose Design default.', 'NAME_COLOR_UNAVAILABLE', { reference: 'PP-NAME-COLOR' });
          }
          targets.push({ uuid, color, label, side, text: valueId(field.value), fontFamily: item.info.curveText.fontFamily });
          // fillForm accepts text only, not styles. Use the vendor's exposed design
          // methods after native form rendering. Change just these authorised name
          // fills; leave native form state, original templates and every logo intact.
          if (canonical(item.info.curveText.fill) !== color) {
            item.info.curveText.fill = color;
            changed = true;
          }
        }
      }
      abortCheck(signal);
      if (!changed) {
        this._checkNameColors(engine.getDesigns(), targets, false);
        return targets;
      }
      if (typeof engine.setDesigns !== 'function' || typeof engine.renderAll !== 'function') fail('The manufacturer does not currently support name colour selection for this tee.', 'NAME_COLOR_UNAVAILABLE', { reference: 'PP-NAME-COLOR' });
      try {
        engine.setDesigns(designs);
        await bounded(() => engine.renderAll(), 90000, signal, 'The name colours took too long to render.');
        await this._awaitDesignReady(context, signal);
        this._checkNameColors(engine.getDesigns(), targets, false);
      } catch (error) {
        if (error.code === 'ABORTED' || error.code === 'TIMEOUT' || error.reloadRequired) throw error;
        fail('The manufacturer could not render the selected name colours. Reference: PP-NAME-COLOR.', 'NAME_COLOR_MISMATCH', { reference: 'PP-NAME-COLOR', reloadRequired: true, cause: error });
      }
      return targets;
    }

    async _logoValue(file, field, context, urls, signal) {
      const win = context.win;
      const inputUrl = win.URL.createObjectURL(file);
      urls.push(inputUrl);
      const image = await bounded(() => new Promise((resolve, reject) => {
        const element = new win.Image();
        element.onload = () => resolve(element);
        element.onerror = () => reject(new TeamOrderError(field.title + ' is not a readable JPG or PNG.', 'INVALID_LOGO'));
        element.src = inputUrl;
      }), 30000, signal, field.title + ' took too long to read.');
      const width = image.naturalWidth || image.width;
      const height = image.naturalHeight || image.height;
      const targetRatio = Number(field.requiredWidth) / Number(field.requiredHeight);
      if (!(width > 0 && height > 0 && targetRatio > 0 && Number.isFinite(targetRatio))) fail(field.title + ' has no usable print-area dimensions.', 'SDK_CONFIGURATION');
      let originUrl = inputUrl;
      let originWidth = width;
      let originHeight = height;
      let renderImage = image;
      const makeUrl = async canvas => {
        const blob = await bounded(() => new Promise((resolve, reject) => canvas.toBlob(value => value ? resolve(value) : reject(new TeamOrderError(field.title + ' could not be prepared.', 'INVALID_LOGO')), 'image/png')), 30000, signal, field.title + ' took too long to prepare.');
        const url = win.URL.createObjectURL(blob);
        urls.push(url);
        return url;
      };
      // Native Yoycol upload crops to the print-area ratio. The team flow contains
      // the complete logo in that ratio using transparent padding, never stretching.
      if (Math.abs(width / height - targetRatio) > 0.0001) {
        originWidth = Math.ceil(Math.max(width, height * targetRatio));
        originHeight = Math.ceil(originWidth / targetRatio);
        const mobile = /Android|iPhone|iPad|Mobile/i.test(win.navigator && win.navigator.userAgent || '');
        if (originWidth > 32767 || originHeight > 32767 || originWidth * originHeight > (mobile ? 67108864 : 267257104)) fail(field.title + ' is too large to fit this print area. Use a smaller exported logo.', 'INVALID_LOGO');
        const canvas = win.document.createElement('canvas');
        canvas.width = originWidth;
        canvas.height = originHeight;
        const drawing = canvas.getContext('2d');
        if (!drawing) fail(field.title + ' could not be prepared.', 'INVALID_LOGO');
        drawing.drawImage(image, (originWidth - width) / 2, (originHeight - height) / 2, width, height);
        originUrl = await makeUrl(canvas);
        renderImage = canvas;
      }
      let thumbnailUrl = originUrl;
      let thumbWidth = originWidth;
      let thumbHeight = originHeight;
      if (originWidth > 1200) {
        thumbWidth = 1200;
        thumbHeight = Math.max(1, Math.round(originHeight * 1200 / originWidth));
        const canvas = win.document.createElement('canvas');
        canvas.width = thumbWidth;
        canvas.height = thumbHeight;
        const drawing = canvas.getContext('2d');
        if (!drawing) fail(field.title + ' could not be prepared.', 'INVALID_LOGO');
        drawing.drawImage(renderImage, 0, 0, thumbWidth, thumbHeight);
        thumbnailUrl = await makeUrl(canvas);
      }
      return { thumbnailUrl, url: originUrl, name: file.name, width: thumbWidth, height: thumbHeight, originWidth, size: originWidth + '*' + originHeight };
    }

    _disposeHost() {
      if (this.host) { this.host.remove(); this.host = null; }
    }

    async _sdk(product, signal) {
      if (!global.Shopify || global.Shopify.shop !== this.shopDomain) fail('The manufacturer personalizer requires the Shopify storefront.', 'SHOP_DOMAIN_MISMATCH');
      if (global.__paneBundleOwner && global.__paneBundleOwner !== this) fail('Another team personalizer is already active.', 'SDK_IN_USE');
      if (!global.__paneBundleOwner && ((global.yoycolShop && global.yoycolShop.customized) || global.yoycolPrds)) fail('Open bundle building on its dedicated page so the product personalizer can remain independent.', 'SDK_IN_USE');
      global.__paneBundleOwner = this;
      // The vendor engine owns its sized Fabric/WebGL canvases. Its product-page
      // React controller is unnecessary here and can switch variants/remount while
      // a roster row loads. Keep this selector deliberately unmounted: bootstrap's
      // optional UI mount then exits, while the vendor/form APIs remain available.
      global.yoycolShop = { product, customized: true, design_mode: false, selector: '#' + this.hostId };
      let newlyLoaded = false;
      if (!global.yoycolVendor || !global.yoycolPersonalizer) {
        newlyLoaded = true;
        const script = global.document.createElement('script');
        script.async = true;
        script.src = 'https://clkj-online.oss-accelerate.aliyuncs.com/shopify-sdk/bootstrap.js';
        const loading = new Promise((resolve, reject) => {
          script.addEventListener('load', resolve, { once: true });
          script.addEventListener('error', () => reject(new TeamOrderError('The manufacturer SDK could not load.', 'SDK_LOAD_FAILED')), { once: true });
        });
        global.document.head.appendChild(script);
        try { await bounded(() => loading, 60000, signal, 'The manufacturer SDK took too long to load.'); }
        finally { script.remove(); }
      }
      const result = await poll(() => {
        const sdk = global.yoycolPersonalizer;
        const vendor = global.yoycolVendor;
        if (!sdk || !vendor) return null;
        if (typeof sdk.getFormFields !== 'function' || typeof sdk.fillForm !== 'function' || typeof vendor.saveDesign !== 'function' || typeof vendor.setProducts !== 'function' || typeof vendor.setShopfiyProducts !== 'function' || typeof vendor.loadProduct !== 'function' || typeof vendor.getOriginDeisgns !== 'function') fail('The installed manufacturer SDK does not provide the required methods.', 'SDK_UNSUPPORTED');
        // The freshly loaded SDK starts an initial model request. Let it settle
        // before requesting another model, preventing that initial request racing a row.
        if (newlyLoaded && !(vendor.products || []).some(model => (model.storeModelSkuList || []).some(item => (product.variants || []).some(variant => sameId(item.variantId, variant.id))))) return null;
        return { sdk, vendor };
      }, 90000, signal, 'The manufacturer SDK did not become ready.');
      return result;
    }

    _designStatus(vendor, sdk, modelIndex, expectedIds) {
      const actualFields = typeof sdk.getFormFields === 'function' ? sdk.getFormFields().map(field => valueId(field.id)).sort() : [];
      const status = {
        reason: 'ready', expectedModel: modelIndex, actualModel: vendor.active,
        expectedFields: expectedIds.length, actualFields: actualFields.length,
        expectedArtwork: 0, actualArtwork: 0, missingArtwork: 0, missingPanels: []
      };
      if (!vendor.engine) status.reason = 'engine_missing';
      else if (vendor.active !== modelIndex) status.reason = 'model_mismatch';
      // The SDK starts a render from its form-store reducer without awaiting it
      // in loadProduct. Only validate artwork once that mutable render has settled.
      else if (vendor.engine.isRenderLoading) status.reason = 'rendering';
      else if (actualFields.join('|') !== expectedIds.join('|')) status.reason = 'fields_mismatch';
      else {
        let origin;
        try {
          origin = infoCanvases(vendor.getOriginDeisgns());
          status.expectedArtwork = elements(origin).length;
        } catch (_) { status.reason = 'origin_unreadable'; }
        if (origin) {
          let actual;
          try { actual = elements(vendor.engine.getDesigns()); }
          catch (_) { status.reason = 'design_unavailable'; }
          if (actual) {
            status.actualArtwork = actual.length;
            const ids = new Set(actual.map(item => item.info && item.info.uuid).filter(Boolean));
            origin.forEach((canvas, index) => {
              const missing = (canvas.klass || []).filter(item => !item.info || !item.info.uuid || !ids.has(item.info.uuid));
              status.missingArtwork += missing.length;
              if (missing.length) status.missingPanels.push(valueId(canvas.canvas_name || index));
            });
            if (!status.expectedArtwork || status.missingArtwork) status.reason = 'artwork_missing';
          }
        }
      }
      this.lastLoadDiagnostics = status;
      return status;
    }

    _designFailure(status) {
      const failures = {
        engine_missing: ['The manufacturer rendering engine did not initialise.', 'PP-ENGINE'],
        model_mismatch: ['The manufacturer loaded a different tee configuration.', 'PP-MODEL'],
        fields_mismatch: ['The manufacturer personalisation options did not finish loading.', 'PP-FIELDS'],
        origin_unreadable: ['The manufacturer returned an unreadable tee template.', 'PP-TEMPLATE'],
        design_unavailable: ['The manufacturer could not open the tee design in its renderer.', 'PP-DESIGN'],
        artwork_missing: ['The manufacturer artwork did not finish loading.', 'PP-ARTWORK'],
        rendering: ['The manufacturer preview rendering did not finish.', 'PP-RENDER']
      };
      const [message, reference] = failures[status.reason] || failures.artwork_missing;
      fail(message + ' Reference: ' + reference + '.', 'DESIGN_NOT_READY', {
        diagnostics: status, reference, reloadRequired: true
      });
    }

    async _awaitDesignReady(context, signal) {
      const { vendor, sdk, modelIndex, options } = context;
      const expectedIds = options.map(option => valueId(option.id)).sort();
      let status = this._designStatus(vendor, sdk, modelIndex, expectedIds);
      if (status.reason === 'rendering') {
        try {
          await poll(() => {
            status = this._designStatus(vendor, sdk, modelIndex, expectedIds);
            if (!['ready', 'rendering'].includes(status.reason)) this._designFailure(status);
            return status.reason === 'ready';
          }, 20000, signal, 'The manufacturer preview rendering did not finish.');
        } catch (error) {
          if (error.code === 'TIMEOUT') this._designFailure(status);
          throw error;
        }
      }
      if (status.reason !== 'ready') this._designFailure(status);
    }

    async _resetPreviousPlayer(sdk, vendor, signal) {
      const previous = this.loadedContext;
      if (!previous) return;
      // Native saveDesign uploads then revokes blob URLs, but the native form
      // store retains them on loadProduct. Clear active inputs through the public
      // API while the previous model's origin is still available, BEFORE reloading.
      // Keeping our own URLs alive cannot fix the vendor's independent revocation.
      if (previous.sdk !== sdk || previous.vendor !== vendor || vendor.active !== previous.modelIndex ||
          vendor.products[previous.modelIndex] !== previous.model || !vendor.engine) {
        fail('The manufacturer configuration changed between players. Reference: PP-RESET.', 'PLAYER_RESET_FAILED', { reference: 'PP-RESET', reloadRequired: true });
      }
      try {
        await poll(() => !vendor.engine.isRenderLoading, 20000, signal, 'The previous tee’s artwork did not finish rendering.');
        const fields = sdk.getFormFields();
        const expectedIds = previous.options.map(option => valueId(option.id)).sort();
        if (fields.map(field => valueId(field.id)).sort().join('|') !== expectedIds.join('|')) {
          fail('The manufacturer fields changed between players.', 'PLAYER_RESET_FAILED');
        }
        const reset = {};
        fields.forEach(field => {
          if (field.type === 'image') reset[field.id] = null;
          else if (field.type === 'text') reset[field.id] = '';
          else fail('A manufacturer field cannot be reset safely.', 'PLAYER_RESET_FAILED');
        });
        await bounded(() => sdk.fillForm(reset), 90000, signal, 'The manufacturer could not reset the previous tee’s artwork.');
        await this._awaitDesignReady(previous, signal);
        this.loadedContext = null;
      } catch (error) {
        if (error.code === 'ABORTED' || error.code === 'TIMEOUT' || error.reloadRequired) throw error;
        fail('The manufacturer could not reset the previous tee’s artwork. Reference: PP-RESET.', 'PLAYER_RESET_FAILED', { reference: 'PP-RESET', reloadRequired: true, cause: error });
      }
    }

    async _loadManufacturerDesign(vendor, modelIndex, signal) {
      let probeTimer;
      let stopped = false;
      // In the observed SDK, loadModel assigns modelUrl then synchronously
      // assigns createEngine() to engine inside an async Promise executor. When
      // graphics startup throws, its outer promise never settles. Inspect that
      // specific failed initialization state instead of waiting 90 seconds.
      // Do not modify the renderer, choose an unlisted mockup, or suppress errors.
      const failedStartup = new Promise((resolve, reject) => {
        const probe = () => {
          if (stopped) return;
          const mockup = vendor.mockup;
          for (const key of ['renderer3Dto2D', 'renderer3D']) {
            const renderer = mockup && mockup[key];
            if (renderer && typeof renderer.modelUrl === 'string' && renderer.modelUrl &&
                !renderer.engine && typeof renderer.createEngine === 'function' && typeof renderer.loadModel === 'function') {
              reject(new TeamOrderError('The manufacturer could not start the graphics renderer for this tee. Reference: PP-GRAPHICS.', 'RENDERER_START_FAILED', {
                reference: 'PP-GRAPHICS', reloadRequired: true,
                diagnostics: { reason: 'renderer_start_failed', rendererType: key === 'renderer3D' ? '3D' : '3Dto2D' }
              }));
              return;
            }
          }
          probeTimer = global.setTimeout(probe, 100);
        };
        probeTimer = global.setTimeout(probe, 100);
      });
      try {
        await bounded(() => Promise.race([Promise.resolve().then(() => vendor.loadProduct(modelIndex, true)), failedStartup]), 90000, signal, 'The manufacturer design took too long to load.');
      } finally {
        stopped = true;
        global.clearTimeout(probeTimer);
      }
    }

    async _standardRow(groupId, row, signal) {
      if (row.personalize !== false || (row.name || '').trim()) fail('Confirm whether this tee should have a name.', 'FIELD_INVALID');
      if (!global.Shopify || global.Shopify.shop !== this.shopDomain) fail('Open the bundle on the storefront to continue.', 'SHOP_DOMAIN_MISMATCH');
      const productUrl = new global.URL('products/' + encodeURIComponent(row.handle) + '.js', this.root);
      let product = this.batchProducts && this.batchProducts.get(productUrl.href);
      if (!product) {
        const response = await this._request(productUrl.href, { headers: { Accept: 'application/json' }, cache: 'no-store' }, signal, 30000);
        if (!response.ok) fail('This tee could not be checked. Please try again.', 'PRODUCT_LOAD_FAILED');
        product = await bounded(() => response.json(), 20000, signal, 'This tee took too long to load.');
        if (this.batchProducts) this.batchProducts.set(productUrl.href, product);
      }
      if (!sameId(product.id, row.productId)) fail('This tee could not be matched to its original design.', 'PRODUCT_MISMATCH');
      const variant = (product.variants || []).find(item => sameId(item.id, row.variantId));
      if (!variant || variant.available === false) fail('This tee’s selected size is unavailable.', 'VARIANT_UNAVAILABLE');
      const modelUrl = new global.URL('https://www.yoycol.com/api/store/product_model/shopify/model_config');
      modelUrl.searchParams.set('domain', this.shopDomain);
      modelUrl.searchParams.set('productId', valueId(row.productId));
      let models = this.standardModels && this.standardModels.get(valueId(row.productId));
      if (!models) {
        const response = await this._request(modelUrl.href, { credentials: 'omit', mode: 'cors', cache: 'no-store', headers: { Accept: 'application/json' } }, signal, 30000);
        if (!response.ok) fail('The original tee design could not be checked. Please try again.', 'BASE_DESIGN_UNAVAILABLE');
        const result = await bounded(() => response.json(), 20000, signal, 'The original design took too long to load.');
        if (String(result.code) !== '100000' || !Array.isArray(result.data)) fail('The original tee design could not be checked. Please try again.', 'BASE_DESIGN_UNAVAILABLE');
        models = result.data;
        this.standardModels?.set(valueId(row.productId), models);
      }
      const matches = models.filter(model => (model.storeModelSkuList || []).some(item => sameId(item.variantId, row.variantId)));
      if (matches.length !== 1) fail('This size has no unique original design.', 'VARIANT_MAPPING');
      const model = matches[0], mapping = model.storeModelSkuList.find(item => sameId(item.variantId, row.variantId));
      if (!/^[A-Za-z0-9_-]{1,128}$/.test(model.designCode || '') || mapping.designCode !== model.designCode) fail('The original design mapping is incomplete.', 'VARIANT_MAPPING');
      const options = fieldOptions(model);
      if (options.length !== 1 || options[0].type !== 'group' || canonical(options[0].form?.name) !== 'add your name (free)') fail('This tee’s original design needs checking before it can be ordered without a name.', 'BASE_DESIGN_UNAVAILABLE');
      const positions = options[0].selectPositions;
      const artwork = elements(model.designInfo);
      if (!Array.isArray(positions) || !positions.length || !positions.every(id => {
        const found = artwork.filter(item => item.info?.uuid === id);
        return found.length === 1 && found[0].info.curveText?.text === '' && (!found[0].objects || found[0].objects.length === 0);
      })) fail('This tee’s original artwork is not confirmed without a name. Please contact us.', 'BASE_DESIGN_NOT_BLANK');
      const properties = { _yoycol_design_code: model.designCode, _pane_bundle: groupId, _pane_row: valueId(row.rowId), Personalisation: 'No name' };
      const proof = { rowId: row.rowId, variantId: row.variantId, designCode: model.designCode, kind: 'standard', properties };
      this.proofs.set(groupId + ':' + valueId(row.rowId), { proof, rowSignature: rowSignature(row), propertySignature: propertySignature(properties), kind: 'standard' });
      return proof;
    }

    async _frame(row, signal, logos = {}, nameColors = { front: null, back: null }) {
      try {
        const productUrl = new global.URL('products/' + encodeURIComponent(row.handle) + '.js', this.root);
        // Cache only within this explicit preparation. A later generation fetches
        // current product availability again; failures are never cached.
        let product = this.batchProducts && this.batchProducts.get(productUrl.href);
        if (!product) {
          const response = await this._request(productUrl.href, { headers: { Accept: 'application/json' }, cache: 'no-store' }, signal, 30000);
          if (!response.ok) fail('The selected product could not be loaded.', 'PRODUCT_LOAD_FAILED');
          product = await bounded(() => response.json(), 20000, signal, 'The selected product took too long to read.');
          if (sameId(product.id, row.productId) && this.batchProducts) this.batchProducts.set(productUrl.href, product);
        }
        if (!sameId(product.id, row.productId)) fail('The product does not match this tee’s selected tee.', 'PRODUCT_MISMATCH');
        const variant = (product.variants || []).find(item => sameId(item.id, row.variantId));
        if (!variant || variant.available === false) fail('This tee’s selected size is unavailable.', 'VARIANT_UNAVAILABLE');
        product.options = (product.options || []).map(option => typeof option === 'string' ? option : option.name);
        const { sdk, vendor } = await this._sdk(product, signal);
        const previous = this.loadedContext;
        const configured = this.batchManufacturer;
        const reuseConfiguration = configured && configured.vendor === vendor &&
          sameId(configured.productId, row.productId) && configured.models === vendor.products;
        // Keep the public reset even for a compatible model: saveDesign revokes
        // blobs retained by native fields. Reuse must never resurrect those URLs.
        await this._resetPreviousPlayer(sdk, vendor, signal);
        if (!reuseConfiguration) {
          this.batchManufacturer = null;
          // setShopfiyProducts swallows request errors in the current SDK. Clear
          // prior models so a failed request cannot reuse the previous product.
          vendor.setProducts([]);
          await bounded(() => vendor.setShopfiyProducts(this.shopDomain, valueId(row.productId)), 90000, signal, 'The manufacturer configuration took too long to load.');
        }
        const matches = (vendor.products || []).map((model, index) => ({ model, index })).filter(({ model }) => (model.storeModelSkuList || []).some(item => sameId(item.variantId, row.variantId)));
        if (matches.length !== 1) fail('This variant has no unique manufacturer design mapping.', 'VARIANT_MAPPING');
        const { model, index: modelIndex } = matches[0];
        this._validateTemplateCapabilities(model, row, logos, nameColors);
        const mapping = model.storeModelSkuList.find(item => sameId(item.variantId, row.variantId));
        const rgb = String(mapping.skuCode || '').match(/^[^-]+-[^-]+-[^-]+-([a-fA-F0-9]{6})/);
        if (!rgb || typeof vendor.setSkuColor !== 'function') fail('The manufacturer color mapping is missing.', 'VARIANT_MAPPING');
        const skuColor = '#' + rgb[1];
        const reuseModel = reuseConfiguration && previous && previous.sdk === sdk && previous.vendor === vendor &&
          sameId(previous.productId, row.productId) && previous.model === model && previous.modelIndex === modelIndex &&
          previous.skuColor === skuColor && vendor.active === modelIndex;
        vendor.setSkuColor(skuColor);
        if (!reuseModel) {
          await this._loadManufacturerDesign(vendor, modelIndex, signal);
        }
        const options = fieldOptions(model);
        // loadActiveProduct swallows internal load failures. After its awaited
        // completion, missing fields/artwork are a failure, not another 90-second
        // loading phase. Only an explicitly active render warrants a short wait.
        const context = { win: global, sdk, vendor, variant, model, modelIndex, options, productId: row.productId, skuColor, release() {} };
        await this._awaitDesignReady(context, signal);
        if (this.batchProducts) this.batchManufacturer = { vendor, productId: row.productId, models: vendor.products };
        this.loadedContext = context;
        return context;
      } catch (error) { this._disposeHost(); throw error; }
    }

    async _prepareRow(groupId, row, logos, signal, nameColors = { front: null, back: null }, report = () => {}) {
      const context = await this._frame(row, signal, logos, nameColors);
      report(1, 'personalising');
      const blobUrls = [];
      try {
        const { sdk, vendor, model, win, options } = context;
        const fields = sdk.getFormFields();
        const byLabel = this._fieldsByLabel(fields);
        const values = {};
        const nameFields = fields.filter(field => field.type === 'text' && canonical(field.title) === 'add your name (free)');
        if (nameFields.length !== 1 || fields.length !== 1) fail('The name personaliser could not be matched to this tee.', 'FIELD_MISSING');
        const nameField = nameFields[0];
        const requestedName = row.name || '';
        if (nameField.required && !requestedName.trim()) fail('Enter a name for this tee.', 'FIELD_REQUIRED');
        if (nameField.maxLength && requestedName.length > nameField.maxLength) fail('The name exceeds this tee’s character limit.', 'FIELD_INVALID');
        if (nameField.textType === 'alpha' && requestedName && !/^[A-Za-z\s]+$/.test(requestedName)) fail('This name allows only letters and spaces.', 'FIELD_INVALID');
        if (nameField.textType === 'numeric' && requestedName && !/^[\d\s]+$/.test(requestedName)) fail('This name allows only numbers and spaces.', 'FIELD_INVALID');
        if (nameField.textType === 'alphanumeric' && requestedName && !/^[A-Za-z0-9\s]+$/.test(requestedName)) fail('This name allows only letters, numbers and spaces.', 'FIELD_INVALID');
        values[nameField.id] = requestedName;
        for (const label of LOGO_LABELS) {
          const field = byLabel.get(canonical(label));
          if (!logos[label]) {
            // Explicit absence matters: an earlier preparation may have used a
            // logo here. null restores this model's original image placeholder.
            if (field && field.type === 'image') values[field.id] = null;
            continue;
          }
          if (!field || field.type !== 'image' || !['both', 'upload'].includes(field.imageSource)) fail(label + ' cannot be uploaded on this tee.', 'FIELD_MISSING');
          // File objects are not accepted directly by fillForm. Each row gets fresh URLs.
          values[field.id] = await this._logoValue(logos[label], field, context, blobUrls, signal);
        }
        for (const field of fields) {
          const value = Object.prototype.hasOwnProperty.call(values, field.id) ? values[field.id] : field.value;
          if (field.required && (value == null || value === '')) fail(field.title + ' is required for this tee.', 'FIELD_REQUIRED');
        }
        await bounded(() => sdk.fillForm(values), 90000, signal, 'The tee personalisation took too long to render.');
        // Check all original artwork again AFTER applying the current player's
        // names/logos. No manufacturer save is allowed from a partial render.
        await this._awaitDesignReady(context, signal);
        const completedFields = sdk.getFormFields();
        const colorTargets = await this._applyNameColors(context, completedFields, nameColors, signal);
        const origin = elements(vendor.getOriginDeisgns());
        abortCheck(signal);
        report(2, 'saving');
        // saveDesign performs upload + manufacturer save once. It does not add to cart.
        const saved = await bounded(() => vendor.saveDesign(), 300000, signal, 'The manufacturer proof could not be saved in time. No cart items were added.');
        abortCheck(signal);
        if (vendor.active !== context.modelIndex || vendor.products[context.modelIndex] !== model) fail('The active manufacturer design changed while saving.', 'VARIANT_MAPPING');
        if (!saved || typeof saved.designCode !== 'string' || !/^[A-Za-z0-9_-]{1,128}$/.test(saved.designCode)) fail('The manufacturer did not return a valid saved design code.', 'INVALID_MANUFACTURER_OUTPUT');
        const savedElements = elements(saved.designInfo);
        if (!origin.every(item => item.info && savedElements.some(current => current.info && current.info.uuid === item.info.uuid))) fail('The saved proof is missing part of the original tee design.', 'INVALID_MANUFACTURER_OUTPUT');
        this._checkNameColors(saved.designInfo, colorTargets, true);
        const previewSource = httpUrl(saved.image, 'The tee preview');
        const properties = { _yoycol_design_code: saved.designCode, preview_image: previewSource, _pane_bundle: groupId, _pane_row: valueId(row.rowId) };
        for (const field of completedFields) {
          const option = options.find(item => item.id === field.id);
          if (!option || !Array.isArray(option.selectPositions) || !option.selectPositions.length) fail('A personalization field has no manufacturer print location.', 'SDK_CONFIGURATION');
          const matches = savedElements.filter(item => item.info && option.selectPositions.includes(item.info.uuid));
          if (!matches.length) fail('A saved personalization location is missing.', 'INVALID_MANUFACTURER_OUTPUT');
          if (field.type === 'text') {
            const value = valueId(field.value);
            // The existing tee templates render names in curveText group metadata.
            if (!matches.every(item => item.info.curveText && valueId(item.info.curveText.text) === value)) fail(field.title + ' did not reach the saved manufacturer design.', 'INVALID_MANUFACTURER_OUTPUT');
            if (value) properties[field.title] = value;
          } else if (field.type === 'image') {
            const current = matches[0];
            const original = origin.find(item => item.info && option.selectPositions.includes(item.info.uuid));
            if (current.src && current.src !== (original && original.src)) properties[field.title] = httpUrl(current.src, field.title);
            if (Object.prototype.hasOwnProperty.call(values, field.id) && values[field.id] !== null) {
              if (!properties[field.title]) fail(field.title + ' did not reach the saved manufacturer design.', 'INVALID_MANUFACTURER_OUTPUT');
              httpUrl(current.info.originUrl, field.title + ' original');
            } else if (values[field.id] === null && properties[field.title]) {
              fail(field.title + ' was not cleared from the saved manufacturer design.', 'INVALID_MANUFACTURER_OUTPUT');
            }
          }
        }
        for (const side of ['front', 'back']) {
          if (nameColors[side]) properties['_pane_' + side + '_name_color'] = nameColors[side];
        }
        report(3, 'loading_preview');
        const previewAsset = await this._previewAsset(previewSource, signal);
        report(4, 'checking_preview');
        const proof = { rowId: row.rowId, variantId: row.variantId, designCode: saved.designCode, previewUrl: previewAsset.url, properties };
        this.previewAssets.set(proof, previewAsset);
        Object.defineProperty(proof, 'nameColors', { value: Object.freeze({ ...nameColors }), enumerable: true });
        this.proofs.set(groupId + ':' + valueId(row.rowId), { proof, rowSignature: rowSignature(row), propertySignature: propertySignature(properties) });
        return proof;
      } finally {
        blobUrls.forEach(url => { try { context.win.URL.revokeObjectURL(url); } catch (_) {} });
        context.release();
      }
    }

    async prepare(input) {
      if (this.busy) fail('A bundle operation is already running.', 'BUSY');
      if (this.needsReload) fail('Refresh this page before preparing the bundle again. The previous manufacturer operation was interrupted.', 'RELOAD_REQUIRED', { reloadRequired: true });
      const { groupId, rows, logos = {}, nameColors: requestedNameColors, signal } = input || {};
      this._validate(groupId, rows);
      this._validateLogos(logos);
      const nameColors = this._validateNameColors(requestedNameColors);
      this.releasePreviews();
      this.busy = true;
      this.batchProducts = new Map();
      this.standardModels = new Map();
      this.batchManufacturer = null;
      const prepared = [];
      try {
        for (let index = 0; index < rows.length; index += 1) {
          abortCheck(signal);
          const row = rows[index];
          const report = (step, stage) => this._progress({ phase: 'preparing', index, total: rows.length, rowId: row.rowId, stage, percent: Math.floor(((index * 5 + step) / (rows.length * 5)) * 100) });
          report(0, 'loading_tee');
          prepared.push(row.personalize === false ? await this._standardRow(groupId, row, signal) : await this._prepareRow(groupId, row, logos, signal, nameColors, report));
          this._progress({ phase: 'prepared', index: index + 1, total: rows.length, rowId: row.rowId, percent: Math.floor(((index + 1) / rows.length) * 100) });
        }
        return prepared;
      } catch (error) {
        // A failed batch cannot be approved. Release review-only images while
        // retaining the manufacturer context needed to reset the next attempt.
        this.releasePreviews();
        // Vendor promises do not accept AbortSignal. A timed-out operation may still
        // be mutating its singleton engine; never start another row on that engine.
        if (error.reloadRequired || error.code === 'TIMEOUT' || error.code === 'ABORTED' || error.name === 'AbortError' || (signal && signal.aborted)) this.needsReload = true;
        const row = rows[prepared.length];
        const cut = 'tee';
        const prefix = row ? 'Tee ' + (prepared.length + 1) + ' (' + row.size + '): ' : '';
        const message = prefix + (error.message || 'The bundle previews could not be prepared.') + (this.needsReload ? ' Refresh this page before preparing the bundle again.' : '');
        // Customer names, files, upload URLs, design codes, and exception stacks
        // must not enter the support summary. Keep only configuration diagnostics.
        const supportDetails = {
          adapterVersion: PaneBundlePersonalizer.version, reference: error.reference || error.code || 'PREPARE_FAILED',
          playerNumber: prepared.length + 1, totalPlayers: rows.length,
          cut: row && row.cut, size: row && row.size, productHandle: row && row.handle,
          productId: row && valueId(row.productId), variantId: row && valueId(row.variantId)
        };
        for (const key of ['reason', 'expectedModel', 'actualModel', 'expectedFields', 'actualFields', 'expectedArtwork', 'actualArtwork', 'missingArtwork', 'missingPanels', 'rendererType', 'supportedFields', 'unsupportedFields']) {
          if (error.diagnostics && Object.prototype.hasOwnProperty.call(error.diagnostics, key)) supportDetails[key] = error.diagnostics[key];
        }
        throw new TeamOrderError(message, error.code || 'PREPARE_FAILED', { rowId: row && row.rowId, preparedCount: prepared.length, totalCount: rows.length, addedCount: 0, prepared, reloadRequired: this.needsReload, reference: error.reference, diagnostics: error.diagnostics, supportDetails, cause: error });
      } finally {
        this.batchProducts = null;
        this.standardModels = null;
        this.batchManufacturer = null;
        this.busy = false;
        this._disposeHost();
      }
    }

    async _request(url, options, signal, timeout) {
      const controller = new global.AbortController();
      const abort = () => controller.abort();
      const timer = global.setTimeout(abort, timeout || 30000);
      if (signal) signal.addEventListener('abort', abort, { once: true });
      try {
        abortCheck(signal);
        return await global.fetch(url, { credentials: 'same-origin', ...options, signal: controller.signal });
      } finally {
        global.clearTimeout(timer);
        if (signal) signal.removeEventListener('abort', abort);
      }
    }

    async _cart(signal) {
      const url = new global.URL('cart.js', this.root);
      url.searchParams.set('_pane_check', String(Date.now()));
      const response = await this._request(url.href, { headers: { Accept: 'application/json' }, cache: 'no-store' }, signal, 20000);
      if (!response.ok) fail('The cart could not be checked. No further tees were submitted.', 'CART_READ_FAILED');
      const cart = await bounded(() => response.json(), 20000, signal, 'The cart response took too long to read.');
      if (!cart || !Array.isArray(cart.items)) fail('The cart returned an unreadable response.', 'CART_READ_FAILED');
      return cart;
    }

    async checkCart(input) {
      const { groupId, prepared, signal } = input;
      const cart = await this._cart(signal);
      return { cart, addedCount: this._confirmed(cart, groupId, prepared).size };
    }

    _confirmed(cart, groupId, prepared) {
      const expected = new Map(prepared.map(proof => [valueId(proof.rowId), proof]));
      const confirmed = new Set();
      for (const item of cart.items) {
        const properties = item.properties || {};
        if (properties._pane_bundle !== groupId) continue;
        const rowId = valueId(properties._pane_row);
        const proof = expected.get(rowId);
        if (!proof || confirmed.has(rowId) || Number(item.quantity) !== 1 || !sameId(item.variant_id || item.id, proof.variantId) || properties._yoycol_design_code !== proof.designCode) fail('This bundle already contains a different or duplicated tee. Review its cart lines before retrying.', 'CART_CONFLICT', { rowId });
        confirmed.add(rowId);
      }
      return confirmed;
    }

    async _form(proof, signal) {
      const form = new global.FormData();
      form.append('id', valueId(proof.variantId));
      form.append('quantity', '1');
      for (const [key, value] of Object.entries(proof.properties)) {
        const isAttachment = key === 'preview_image' || LOGO_LABELS.some(label => canonical(label) === canonical(key));
        if (isAttachment) {
          const attachmentUrl = httpUrl(value, key);
          const asset = key === 'preview_image' && this.previewAssets.get(proof);
          if (asset && asset.sourceUrl === attachmentUrl && this.getPreviewUrl(proof)) {
            form.append('properties[' + key + ']', this._attachmentFile(asset.blob));
            continue;
          }
          const response = await this._request(attachmentUrl, { credentials: 'omit', mode: 'cors' }, signal, 60000);
          if (!response.ok) fail('A saved logo or preview could not be read. No tee was submitted for this tee.', 'ASSET_READ_FAILED');
          const blob = await bounded(() => response.blob(), 60000, signal, 'A saved logo or preview took too long to read.');
          if (!blob.size) fail('A saved logo or preview is empty.', 'ASSET_READ_FAILED');
          // Preserve the multipart file contract and the actual image format.
          form.append('properties[' + key + ']', this._attachmentFile(blob));
        } else form.append('properties[' + key + ']', valueId(value));
      }
      return form;
    }

    async addToCart(input) {
      if (this.busy) fail('A bundle operation is already running.', 'BUSY');
      const { groupId, rows, prepared, signal } = input || {};
      this._validate(groupId, rows);
      if (!Array.isArray(prepared) || prepared.length !== rows.length) fail('Generate a proof for every tee first.', 'PROOF_MISSING');
      const proofs = new Map();
      prepared.forEach(proof => {
        const row = rows.find(item => sameId(item.rowId, proof.rowId));
        const record = this.proofs.get(groupId + ':' + valueId(proof.rowId));
        if (!row || proofs.has(valueId(proof.rowId)) || !record || record.proof !== proof || record.rowSignature !== rowSignature(row) || record.propertySignature !== propertySignature(proof.properties) || !sameId(row.variantId, proof.variantId) || proof.properties._yoycol_design_code !== proof.designCode || (row.personalize === false ? record.kind !== 'standard' || proof.kind !== 'standard' : !this.getPreviewUrl(proof)) || proof.properties._pane_bundle !== groupId || !sameId(proof.properties._pane_row, proof.rowId)) fail('The roster or proof changed. Generate and review the bundle previews again.', 'PROOF_CHANGED');
        proofs.set(valueId(proof.rowId), proof);
      });
      this.busy = true;
      let confirmed = new Set();
      let cart = null;
      let newlyAddedCount = 0;
      let retrySafe = true;
      try {
        this._progress({ phase: 'checking', index: 0, total: rows.length });
        cart = await this._cart(signal);
        confirmed = this._confirmed(cart, groupId, prepared);
        for (let index = 0; index < rows.length; index += 1) {
          abortCheck(signal);
          const row = rows[index];
          if (confirmed.has(valueId(row.rowId))) continue;
          const proof = proofs.get(valueId(row.rowId));
          this._progress({ phase: 'adding', index, total: rows.length, rowId: row.rowId, addedCount: confirmed.size });
          const form = await this._form(proof, signal);
          abortCheck(signal);
          let response;
          let submissionError = null;
          try {
            response = await this._request(new global.URL('cart/add.js', this.root).href, { method: 'POST', headers: { Accept: 'application/json' }, body: form }, signal, 60000);
            if (!response.ok) submissionError = new TeamOrderError('Shopify could not add this tee (HTTP ' + response.status + ').', 'CART_ADD_FAILED');
            else {
              const result = await bounded(() => response.json(), 20000, signal, 'The cart submission response took too long to read.');
              const item = Array.isArray(result.items) ? result.items[0] : result;
              if (!item || !sameId(item.variant_id || item.id, proof.variantId) || !item.properties || item.properties._yoycol_design_code !== proof.designCode || item.properties._pane_bundle !== groupId || !sameId(item.properties._pane_row, proof.rowId)) submissionError = new TeamOrderError('The cart submission returned an unexpected tee. Check the cart before continuing.', 'CART_RESPONSE_MISMATCH');
            }
          } catch (error) { submissionError = error; }
          // A timed-out/aborted POST may have committed. A read is the only safe recovery.
          let after;
          try {
            cart = null;
            cart = await this._cart();
            after = this._confirmed(cart, groupId, prepared);
          }
          catch (error) {
            retrySafe = false;
            fail('The last cart submission could not be verified. Check the cart before trying again; no further tees were submitted.', error.code === 'CART_CONFLICT' ? 'CART_CONFLICT' : 'CART_STATUS_UNKNOWN', { cause: error, rowId: row.rowId });
          }
          const wasAdded = after.has(valueId(row.rowId));
          if (wasAdded && !confirmed.has(valueId(row.rowId))) newlyAddedCount += 1;
          confirmed = after;
          if (submissionError) fail('The last cart submission was interrupted. ' + confirmed.size + ' of ' + rows.length + ' tees are confirmed in the cart. Review the cart, then retry the remaining rows with these proofs.', 'CART_SUBMISSION_INTERRUPTED', { cause: submissionError, rowId: row.rowId });
          if (!wasAdded) fail('The tee was not found in the cart after submission. No further tees were submitted.', 'CART_NOT_CONFIRMED', { rowId: row.rowId });
          this._progress({ phase: 'added', index: index + 1, total: rows.length, rowId: row.rowId, addedCount: confirmed.size });
        }
        if (confirmed.size !== rows.length) fail('Some tees are missing from your cart. Please retry to add only the missing tees.', 'CART_NOT_CONFIRMED');
        return { cartUrl: new global.URL('cart', this.root).href, cart, addedCount: confirmed.size, newlyAddedCount };
      } catch (error) {
        throw new TeamOrderError(error.message || 'The bundle could not be added to the cart.', error.code || 'CART_FAILED', { cart, addedCount: confirmed.size, newlyAddedCount, totalCount: rows.length, completedRowIds: [...confirmed], pendingRowIds: rows.filter(row => !confirmed.has(valueId(row.rowId))).map(row => row.rowId), retrySafe: retrySafe && error.code !== 'CART_CONFLICT', rowId: error.rowId, cause: error });
      } finally { this.busy = false; }
    }
  }

  PaneBundlePersonalizer.Error = TeamOrderError;
  PaneBundlePersonalizer.version = 'pane-1.2.0';
  global.PaneBundlePersonalizer = PaneBundlePersonalizer;
})(window);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-product-page"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pane-product-sizing')) {
  customElements.define('pane-product-sizing', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const section = this.closest('.shopify-section');
      if (!section) return;
      section.addEventListener('click', async event => {
        const trigger = event.target.closest('[data-pane-size-guide]');
        if (!trigger) return;
        event.preventDefault();
        await customElements.whenDefined('pane-size-guide');
        if (!this.isConnected) return;
        const radioGroup = section.querySelector('.product-details [data-pane-size-option]');
        this.querySelector('pane-size-guide')?.show({
          title: this.dataset.productTitle,
          radioGroup,
          trigger
        });
      }, {signal: this.abortController.signal});
    }
    disconnectedCallback() {
      this.abortController?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pp-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pane-size-guide')) {
  class PaneSizeGuide extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.unit = 'cm';
      this.dialog = this.querySelector('dialog');
      this.field = this.querySelector('[data-size-width]');
      this.output = this.querySelector('[data-size-result]');
      this.apply = this.querySelector('[data-size-apply]');
      this.labels = this.querySelector('[data-size-labels]').dataset;
      this.rows = [...this.querySelectorAll('[data-chart-row]')].map(el => ({el, size:el.dataset.size, width:Number(el.dataset.width), length:Number(el.dataset.length)}));
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-size-close')) this.dialog.close();
        if (button.dataset.sizeUnit) this.setUnit(button.dataset.sizeUnit);
        if (button.hasAttribute('data-size-apply')) this.applySize();
      });
      this.querySelector('form').addEventListener('submit', event => { event.preventDefault(); event.stopPropagation(); this.compare(); });
      this.field.addEventListener('input', () => this.clearResult());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => this.trigger?.focus());
    }
    show({title, select, radioGroup, trigger} = {}) {
      this.select = select || null;
      this.radioGroup = radioGroup || null;
      this.trigger = trigger || null;
      this.clearResult();
      const product = this.querySelector('[data-size-product]');
      product.textContent = title || '';
      product.hidden = !title;
      if (!this.dialog.open) this.dialog.showModal();
      this.dialog.scrollTop = 0;
      this.querySelector('[data-size-close]').focus({preventScroll:true});
    }
    clearResult() {
      this.match = null;
      this.apply.hidden = true;
      this.output.textContent = '';
      this.field.removeAttribute('aria-invalid');
      this.rows.forEach(row => row.el.removeAttribute('data-closest'));
    }
    format(cm) { return Number((this.unit === 'in' ? cm / 2.54 : cm).toFixed(1)).toString(); }
    setUnit(unit) {
      if (!['cm','in'].includes(unit) || unit === this.unit) return;
      const number = Number(this.field.value);
      if (this.field.value && Number.isFinite(number)) this.field.value = Number((unit === 'in' ? number / 2.54 : number * 2.54).toFixed(1));
      this.unit = unit;
      this.querySelectorAll('[data-cm]').forEach(cell => cell.textContent = this.format(Number(cell.dataset.cm)));
      this.querySelectorAll('[data-unit-label]').forEach(el => el.textContent = '(' + unit + ')');
      this.querySelectorAll('[data-size-unit]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sizeUnit === unit)));
      this.clearResult();
    }
    compare() {
      this.clearResult();
      const value = Number(this.field.value);
      if (!this.field.value || !Number.isFinite(value) || value <= 0) {
        this.output.textContent = this.labels.invalid;
        this.field.setAttribute('aria-invalid','true');
        this.field.focus();
        return;
      }
      const width = this.unit === 'in' ? value * 2.54 : value;
      // A displayed one-decimal inch value can differ from the original by 0.127cm.
      if (width < this.rows[0].width - 0.13 || width > this.rows.at(-1).width + 0.13) {
        this.output.textContent = this.labels.outside;
        return;
      }
      this.match = this.rows.reduce((best, row) => Math.abs(row.width-width) <= Math.abs(best.width-width) ? row : best);
      this.match.el.setAttribute('data-closest','true');
      this.output.textContent = this.labels.prefix + ' ' + this.match.size + ' — ' + this.format(this.match.width) + ' ' + this.unit + '. ' + this.labels.length + ' ' + this.format(this.match.length) + ' ' + this.unit + '. ' + this.labels.note;
      const option = this.findOption(this.match.size);
      if ((this.select || this.radioGroup) && !option) this.output.textContent += ' ' + this.labels.unavailable;
      this.apply.hidden = !option || Boolean(this.select?.disabled);
    }
    findOption(size) {
      if (!size) return null;
      const normalize = value => {
        const text = value.trim().toUpperCase();
        return /^X{2,5}L$/.test(text) ? (text.length - 1) + 'XL' : text;
      };
      if (this.radioGroup) {
        return [...this.radioGroup.querySelectorAll('input[type="radio"]')].find(input =>
          !input.disabled && input.dataset.optionAvailable !== 'false' && input.getAttribute('aria-disabled') !== 'true' && normalize(input.value) === normalize(size)
        );
      }
      if (!this.select) return null;
      return [...this.select.options].find(option => !option.disabled && option.value && normalize(option.textContent) === normalize(size));
    }
    applySize() {
      const option = this.findOption(this.match?.size);
      if (!option || this.select?.disabled) return;
      if (this.radioGroup) {
        this.trigger = option;
        this.dialog.close();
        option.click();
        return;
      }
      this.select.value = option.value;
      this.select.dispatchEvent(new Event('change', {bubbles:true}));
      this.trigger = this.select;
      this.dialog.close();
    }
  }
  customElements.define('pane-size-guide', PaneSizeGuide);
}
  } catch(e) { console.error(e); }
})();

})();
